import React from 'react';
import { FormData, FormErrors } from '../../types';
import { FormField, Select } from '../FormField';
interface SectionProps {
  data: FormData;
  errors: FormErrors;
  onChange: (field: keyof FormData, value: any) => void;
}
export function Section5({
  data,
  errors,
  onChange
}: SectionProps) {
  const handleActividadChange = (actividad: string) => {
    const current = data.actividad || [];
    if (current.includes(actividad)) {
      onChange('actividad', current.filter(a => a !== actividad));
    } else {
      onChange('actividad', [...current, actividad]);
    }
  };
  return <div className="space-y-6" data-id="element-106">
      <div className="mb-8 border-b border-plateado/30 pb-4" data-id="element-107">
        <h2 className="font-serif text-2xl text-azul-profundo" data-id="element-108">
          <span className="text-dorado mr-2" data-id="element-109">Sección 05 ·</span>
          Movimiento y Actividad Física
        </h2>
        <p className="text-gray-600 mt-2" data-id="element-110">
          El cuerpo está diseñado para moverse. ¿Cómo lo haces tú?
        </p>
      </div>

      <FormField label="¿Con qué frecuencia haces ejercicio actualmente?" name="ejercicio" error={errors.ejercicio} required data-id="element-111">
        <div className="space-y-3 mt-2" data-id="element-112">
          {['Ninguna (sedentario/a)', '1 a 2 veces por semana', '3 a 4 veces por semana', '5 o más veces por semana'].map(option => <label key={option} className="flex items-center space-x-3 p-3 border-2 border-plateado rounded-xl cursor-pointer hover:border-dorado transition-colors bg-white" data-id="element-113">
              <input type="radio" name="ejercicio" value={option} checked={data.ejercicio === option} onChange={e => onChange('ejercicio', e.target.value)} className="w-5 h-5 text-dorado focus:ring-dorado" data-id="element-114" />
              <span className="text-texto-oscuro" data-id="element-115">{option}</span>
            </label>)}
        </div>
      </FormField>

      <FormField label="¿Qué tipo de actividad física prefieres o te gustaría hacer?" name="actividad" error={errors.actividad} required description="Puedes seleccionar varias opciones." data-id="element-116">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2" data-id="element-117">
          {['Caminar / Trotar', 'Yoga / Pilates', 'Entrenamiento de Fuerza / Pesas', 'Cardio / HIIT', 'Baile / Zumba', 'Deportes (natación, tenis, etc.)', 'Otro'].map(option => <label key={option} className="flex items-center space-x-3 p-3 border-2 border-plateado rounded-xl cursor-pointer hover:border-dorado transition-colors bg-white" data-id="element-118">
              <input type="checkbox" value={option} checked={(data.actividad || []).includes(option)} onChange={() => handleActividadChange(option)} className="w-5 h-5 text-dorado focus:ring-dorado rounded" data-id="element-119" />
              <span className="text-texto-oscuro" data-id="element-120">{option}</span>
            </label>)}
        </div>
      </FormField>

      <FormField label="¿Cuánto tiempo realista tienes disponible al día para moverte?" name="tiempo" error={errors.tiempo} required data-id="element-121">
        <Select id="tiempo" value={data.tiempo} onChange={e => onChange('tiempo', e.target.value)} error={!!errors.tiempo} data-id="element-122">
          <option value="" data-id="element-123">Selecciona...</option>
          <option value="<15" data-id="element-124">Menos de 15 minutos</option>
          <option value="15-30" data-id="element-125">Entre 15 y 30 minutos</option>
          <option value="30-60" data-id="element-126">Entre 30 y 60 minutos</option>
          <option value="60+" data-id="element-127">Más de 1 hora</option>
        </Select>
      </FormField>
    </div>;
}